import * as turf from '@turf/turf';
const LayerControls = (name) => require('../../controls').get(name);

import api from '../../api';
import translate from '../tools/translate';
import Dialog from './Dialog';
import { loading, unloading } from "../../shared";
import { ContextEnum } from '../../../enuns/context.enum';
import moment from 'moment';
import wellknown from 'wellknown';
import environment from '../../environment';
import dialog from '../dialog';
import { MulticriteriaTypesMap } from '../../../enuns/AfterSales/multicriteriaTypes.enum';
import { FeaturePermission } from '../../../constants/feature.permission.helper';

const isAuthorized = (permission, feature) => api.authorization.isAuthorized(permission, feature);

class MulticriteriaAfterSales extends Dialog {
    constructor(area) {
        api.general.log.action(ContextEnum.SelectTool, 'Camada Multicriteria');

        const contexts = [
            { label: translate('Common.MulticriteriaAfterSales'), context: 'MulticriteriaAfterSales', mainLayer: true }
        ];

        const shape =
            area.layerType === 'circle'
                ? turf.buffer(area.layer.toGeoJSON(), area.layer.getRadius(), { units: 'meters' })
                : area.layer.toGeoJSON();

        super(translate("Common.MulticriteriaAfterSales"), area, contexts, null, false);

        const wkt = wellknown.stringify(shape);

        this.init(this._name, area).then(() => {
            if (this.container && this.container.wrapper) {
                this.container.wrapper.hide();
            }
            this.createSecondSelect(wkt);
        });
    }

    populateLayers(forceUpdate = false) {
        this._features = [];
        return Promise.resolve();
    }

    createSecondSelect(wkt) {  
        const multicriteriaTypes = [
            {
                value: 1,
                name: translate(`Common.${MulticriteriaTypesMap.autoParts}`),
                visible: isAuthorized(FeaturePermission.LAYER_AFTER_SALES_MULTICRITERIA.showScoreAutoparts),
            },
            {
                value: 2,
                name: translate(`Common.${MulticriteriaTypesMap.tireRetail}`),
                visible: isAuthorized(FeaturePermission.LAYER_AFTER_SALES_MULTICRITERIA.showScoreTireRetail),
            },
            {
                value: 3,
                name: translate(`Common.${MulticriteriaTypesMap.tireTruck}`),
                visible: isAuthorized(FeaturePermission.LAYER_AFTER_SALES_MULTICRITERIA.showScoreTireTruck),
            }
        ];

        const visibleOptions = multicriteriaTypes
            .filter(x => x.visible)
            .map(x => ({ value: x.value, text: x.name }));

        if (visibleOptions.length === 0) {
            return;
        }

        dialog.select(visibleOptions, (chosenOption) => {
            loading();
            const selectedType = multicriteriaTypes.find(x => x.value === chosenOption);
            const optionName = selectedType ? selectedType.name : chosenOption;
            api.afterSales.get.multicriteria.exportXls(
                null,
                chosenOption,
                `${environment.get('CONFIG.CLIENT')}_Sumario Multicriterio_${optionName}_v${moment().format('YYYYMMDD')}.xlsx`,
                wkt
            ).then(result => {
                unloading();
            });
        });
    }

}

export default MulticriteriaAfterSales;



// WEBPACK FOOTER //
// ./src/scripts/core/selection/MulticriteriaAfterSales.js